/** @file Unit vector of a world angle in degrees (CCW, y-up). */
import { angle } from '@pose2d/math/angle';
import { trig } from '@pose2d/math/trig';
import { vec2 } from '@pose2d/math/vec2';
import type { Vec2 } from '@pose2d/math/types';

/** Writes [cos deg, sin deg] into out and returns it. */
export function unitAt(deg: number, out: Vec2): Vec2 {
  const r = angle.degToRad(deg);
  return vec2.set(out, trig.cos(r), trig.sin(r));
}
